module.exports = __webpack_public_path__ + "videos/freehand-jp.39eb78f.mp4";